module.exports = __webpack_public_path__ + "static/media/pocket-change-mobiles-tiny.625bfe10.jpg";